import { LookupValue } from "../data/lookup-value";

export interface LookupItem {
  id: string;
  value: string;
}


export const LookupValueMapper = {
  toLookupValue(v?: LookupItem | null): LookupValue | null {
    if (!v) return null;
    return { id: v.id, Value: v.value };
  },
  toLookupItem(v?: LookupValue | null): LookupItem | null {
    if (!v) return null;
    return { id: v.id, value: v.Value };
  }

};